
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetogoainnovacab() {



    const cardData =
    {
        keyword: ' Pune to Goa Innova Cab',
        heading: 'Prince Cabs: Pune to Goa Innova Cab',
        headingDescription: 'Prince Cabs provides premium Pune to Goa Innova Cab services, ideal for beach vacations, family holidays, corporate trips, and long weekend getaways. Our spacious Innova and Innova Crysta vehicles are well-maintained and equipped with modern amenities to ensure a safe and comfortable ride along the scenic Konkan route. With professional chauffeurs, flexible travel plans, and on-time pickups, we make your Pune to Goa journey smooth and stress-free. Enjoy convenience, comfort, and affordability with Prince Cabs’ trusted Innova cab service from Pune to Goa.',

        top: 'Top Places to Visit in Goa with Prince Cabs',

   "topPlaces": [
  {
    "title": "Baga Beach",
    "description": "Baga Beach is one of Goa’s most popular beaches, famous for its nightlife, shacks, and water sports. Visitors enjoy parasailing, jet skiing, and banana boat rides. The beachside restaurants serve fresh seafood and Goan delicacies. Tito’s Lane nearby is the hub for pubs and nightclubs. Evenings here are lively with music and dancing. Baga is a perfect mix of fun, food, and adventure."
  },
  {
    "title": "Calangute Beach",
    "description": "Known as the ‘Queen of Beaches,’ Calangute is the largest beach in North Goa. It is bustling with tourists, markets, and adventure sports. Visitors shop for handicrafts, souvenirs, and jewelry from roadside stalls. The beach is ideal for long walks and enjoying golden sunsets. Shacks offer chilled drinks and Goan curries. Calangute is lively throughout the year, especially during Christmas and New Year."
  },
  {
    "title": "Fort Aguada",
    "description": "Fort Aguada, built by the Portuguese in the 17th century, stands tall overlooking the Arabian Sea. It was constructed to guard against Dutch and Maratha invasions. The fort has a lighthouse and massive walls that make it a scenic heritage spot. Tourists enjoy panoramic views of the coastline from here. It is also a popular photography location. Fort Aguada is a symbol of Goa’s colonial past."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description": "The Basilica of Bom Jesus, a UNESCO World Heritage Site, is one of the most revered churches in Goa. It houses the mortal remains of St. Francis Xavier, attracting pilgrims worldwide. Built in baroque style, the church features ornate altars, gilded décor, and historic paintings. Its spiritual aura and architectural beauty make it a must-visit. The annual feast in December draws large crowds. It is a cornerstone of Goa’s Christian heritage."
  },
  {
    "title": "Se Cathedral",
    "description": "Se Cathedral, dedicated to St. Catherine, is one of Asia’s largest churches. Built in Portuguese-Gothic style, it is known for its massive bell called the Golden Bell. The cathedral’s interiors feature intricate carvings, altars, and paintings. It is part of the UNESCO-listed churches of Old Goa. Visitors admire its grandeur and spiritual significance. Se Cathedral is both a religious and architectural marvel."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description": "Dudhsagar Waterfalls, located on the Goa-Karnataka border, is one of India’s tallest waterfalls. Cascading from a height of over 300 meters, it looks like a stream of milk, hence the name ‘Dudhsagar.’ Visitors reach it by trekking or via jeep safaris through the Bhagwan Mahavir Sanctuary. The falls are most spectacular during monsoon. Surrounded by lush forests, it is a paradise for nature lovers and photographers."
  },
  {
    "title": "Anjuna Beach",
    "description": "Anjuna Beach is famous for its hippie culture, trance parties, and flea market. Every Wednesday, the beach hosts a colorful market selling clothes, jewelry, and handicrafts. Tourists enjoy live music, yoga sessions, and vibrant nightlife here. The rocky shoreline adds to its charm. It is popular among international travelers and backpackers. Anjuna captures the free-spirited vibe of Goa."
  },
  {
    "title": "Palolem Beach",
    "description": "Palolem Beach in South Goa is known for its crescent-shaped coastline and calm waters. The beach is less crowded and ideal for swimming, kayaking, and dolphin-spotting trips. Colorful huts line the shore, offering a laid-back stay. Sunset views are mesmerizing and romantic. Yoga retreats and wellness centers attract global tourists. Palolem is perfect for those seeking peace and natural beauty."
  },
  {
    "title": "Chapora Fort",
    "description": "Chapora Fort, located near Vagator Beach, is a historic fort offering panoramic views of the Arabian Sea. It gained fame after featuring in the Bollywood film ‘Dil Chahta Hai.’ The fort’s ruins are surrounded by green landscapes, making it a popular trekking spot. Tourists enjoy sunsets from the fort’s vantage points. It is a favorite hangout for youth and photographers. Chapora Fort blends history and modern pop culture."
  },
  {
    "title": "Colva Beach",
    "description": "Colva Beach in South Goa is a long stretch of white sand dotted with coconut palms. It is known for its scenic beauty and peaceful atmosphere. Tourists enjoy water sports, sunbathing, and local Goan cuisine at beach shacks. The beach is popular among families and honeymooners. Fishing boats along the coast add rustic charm. Colva is perfect for relaxation away from crowded beaches."
  },
  {
    "title": "Arambol Beach",
    "description": "Arambol Beach is a serene destination in North Goa, popular for its bohemian culture and drum circles. It attracts international travelers for yoga, meditation, and live music gatherings. The beach is lined with cafes offering vegan and organic food. A freshwater lake nearby adds to its uniqueness. Sunsets here are magical with cultural performances. Arambol is ideal for those seeking offbeat experiences."
  },
  {
    "title": "Mangueshi Temple",
    "description": "Mangueshi Temple is one of Goa’s largest and most famous Hindu temples, dedicated to Lord Shiva. It features a seven-story lamp tower, courtyards, and ornate architecture. The temple holds immense religious importance for the local community. Devotees gather here for rituals and annual festivals. Its peaceful surroundings make it spiritually enriching. Mangueshi Temple reflects Goa’s Hindu cultural heritage."
  },
  {
    "title": "Casino Cruises",
    "description": "Goa is the only state in India with offshore casinos, offering unique entertainment experiences. Casino cruises on the Mandovi River provide gaming, live music, and fine dining. Popular names include Deltin Royale and Casino Pride. Tourists enjoy poker, roulette, and slot machines in a lively atmosphere. Night views of the illuminated cruises are stunning. It is a glamorous addition to Goa’s nightlife scene."
  },
  {
    "title": "Spice Plantations",
    "description": "Goa’s spice plantations, located near Ponda, offer guided tours showcasing cardamom, pepper, nutmeg, and cinnamon cultivation. Visitors learn about organic farming and Ayurveda uses of spices. The tours often include traditional Goan meals served on banana leaves. Elephant rides and nature walks add to the experience. The plantations combine education with eco-tourism. It is a refreshing activity beyond beaches."
  },
  {
    "title": "Fontainhas (Latin Quarter)",
    "description": "Fontainhas in Panjim is Goa’s heritage Latin Quarter, known for its Portuguese-style houses, narrow lanes, and vibrant colors. The area has art galleries, bakeries, and heritage hotels. Walking tours showcase its unique architecture and history. The annual art festival brings the neighborhood alive with performances. It feels like stepping into a European town. Fontainhas is a cultural gem in the heart of Goa."
  }
],

"services": [
    {
        "name": "Pune to Goa Taxi Fare",
        "description": "Get the most competitive taxi fare for your journey from Pune to Goa with our well-maintained fleet and transparent pricing. Ideal for both leisure and business travel, our fares include quality service, experienced drivers, and complete assistance during your long-distance road trip to Goa."
    },
    {
        "name": "Pune to Goa Cab Booking",
        "description": "Easily book your Pune to Goa cab online with instant confirmation and flexible pickup options. Our booking service ensures you travel with comfort, punctuality, and complete peace of mind, making your journey to Goa smooth, convenient, and enjoyable."
    },
    {
        "name": "Pune to Goa Innova Cab Booking",
        "description": "Book a spacious and comfortable Innova cab from Pune to Goa, perfect for families, groups, or long-haul travelers. Our vehicles come with air conditioning, ample luggage space, and professional drivers who know the safest and quickest routes to Goa."
    },
    {
        "name": "Innova Taxi in Pune",
        "description": "Hire an Innova taxi in Pune for outstation travel, airport transfers, or city tours. Our cabs are ideal for both business and leisure purposes, offering maximum comfort, reliability, and affordable rates. Choose from flexible rental durations as per your travel needs."
    },
    {
        "name": "7 Seater Innova on Rent in Pune",
        "description": "Get a 7-seater Innova on rent in Pune for group travel, family outings, or corporate tours. Spacious seating, plush interiors, and excellent ride quality make the Innova a preferred choice for outstation trips like Pune to Goa or other weekend destinations."
    },
    {
        "name": "Pune to Goa Innova Cab Package Service",
        "description": "Opt for our Pune to Goa Innova cab package that includes all essentials—fuel, tolls, driver charges, and multiple stop options. Ideal for tourists who want a well-planned, comfortable, and economical Goa trip in a premium MPV like the Innova or Crysta."
    },
    {
        "name": "Pune to Goa Innova Cab Online Booking",
        "description": "Use our seamless online platform to book an Innova cab from Pune to Goa. With instant confirmation, live driver tracking, and flexible payment options, you can plan your long journey without any last-minute hassle or confusion."
    },
    {
        "name": "Pune to Goa Innova Cab Service",
        "description": "Our Pune to Goa Innova cab service offers spacious seating, luggage space, and comfort for long road travel. Whether you are traveling with friends or family, our cabs provide a relaxed, reliable, and enjoyable journey with courteous drivers and clean interiors."
    },
    {
        "name": "Pune to Goa Crysta Cab Fare",
        "description": "Get affordable and transparent fare estimates for your Pune to Goa Innova Crysta cab ride. We offer fixed packages and custom quotes with no hidden charges. Ideal for travelers looking for luxury travel at a reasonable price point."
    },
    {
        "name": "Pune to Goa Dzire vs Innova Taxi",
        "description": "Compare the comfort, space, and travel experience of Dzire vs Innova for your Pune to Goa ride. While Dzire suits small groups and budget travel, Innova provides more room, better comfort, and is ideal for long-distance family or group trips to Goa."
    },
    {
        "name": "Pune to Goa Family Innova",
        "description": "Travel with your entire family from Pune to Goa in a comfortable Innova cab. Spacious interiors, air conditioning, and a smooth ride ensure a pleasant journey. Perfect for weekend getaways, vacations, or festival trips to the scenic beaches of Goa."
    },
    {
        "name": "Pune to Goa Affordable Innova Cab",
        "description": "Choose our affordable Innova cab for Pune to Goa travel without compromising on comfort or safety. Enjoy premium travel features at economical rates, making it the perfect choice for budget-conscious travelers looking for quality and reliability."
    },
    {
        "name": "Luxury Innova Pune to Goa",
        "description": "Experience top-tier travel from Pune to Goa with our luxury Innova cabs. Designed for those who value comfort, space, and a touch of class, these cabs come with leather seating, superior ride quality, and personalized service to make your Goa trip extra special."
    },
    {
        "name": "Pune to Goa Innova Crysta Hire",
        "description": "Hire an Innova Crysta from Pune to Goa for a premium travel experience. With superior suspension, modern features, and extra luggage capacity, the Crysta is perfect for long-distance journeys, ensuring a smooth, stylish, and safe road trip to Goa."
    },
    {
        "name": "Pune to Goa Innova Round Trip Booking",
        "description": "Book a round-trip Innova cab from Pune to Goa with flexible return schedules, complete travel planning, and discounted rates. This service is ideal for vacationers or business travelers who need a comfortable, round-trip ride with no last-minute surprises."
    }
],
"tableData": [
    ["Pune to Goa Taxi Fare", "Pune to Goa Cab Booking"],
    ["Pune to Goa Innova Cab Booking", "Innova Taxi in Pune"],
    ["7 Seater Innova on Rent in Pune", "Pune to Goa Innova Cab Package Service"],
    ["Pune to Goa Innova Cab Online Booking", "Pune to Goa Innova Cab Service"],
    ["Pune to Goa Crysta Cab Fare", "Pune to Goa Dzire vs Innova Taxi"],
    ["Pune to Goa Family Innova", "Pune to Goa Affordable Innova Cab"],
    ["Luxury Innova Pune to Goa", "Pune to Goa Innova Crysta Hire"],
    ["Pune to Goa Innova Round Trip Booking", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Comfortable & Scenic Pune to Goa Innova Cab Service",
        "WhyChoosedescription": "Prince Cabs offers premium Toyota Innova and Innova Crysta cabs for your Pune to Goa journey — a perfect choice for those who want a stress-free and scenic road trip. Whether you're heading to North Goa for beaches and nightlife or South Goa for peace and relaxation, our Innova cabs deliver a luxurious and spacious travel experience over the 10 to 12-hour drive."
    },
    {
        "WhyChooseheading": "Spacious, Clean & Feature-Rich Vehicles",
        "WhyChoosedescription": "Our Innova fleet is known for its roomy interiors, reclining seats, smooth suspension, and large boot space — ideal for group travel with luggage. Whether you’re with friends, family, or kids, enjoy a smooth ride with air conditioning, charging ports, and audio systems to enhance your travel comfort over the long drive."
    },
    {
        "WhyChooseheading": "Expert Drivers with Route Experience & Safety Focus",
        "WhyChoosedescription": "All Prince Cabs drivers are experienced in Pune–Goa routes via Kolhapur or Amboli Ghat. They are trained for long-distance drives, know the best rest stops, and ensure safe, courteous driving with your convenience and safety as the top priority — even on winding ghat sections or night journeys."
    },
    {
        "WhyChooseheading": "Flexible Trip Options – One-Way, Round Trip & Multi-Day Rentals",
        "WhyChoosedescription": "Whether you’re planning a one-way drop to Goa, a weekend getaway with a return trip, or a multi-day stay with local sightseeing in Goa, we offer fully flexible packages with per-kilometer billing or fixed-rate options. Choose pickup from any Pune area like Hadapsar, Hinjewadi, Kothrud, or Pune Airport."
    },
    {
        "WhyChooseheading": "Transparent Pricing with All-Inclusive Fare Options",
        "WhyChoosedescription": "We believe in clear, upfront pricing — no hidden charges. Get a detailed fare quote that includes driver allowance, tolls, taxes, and parking (if applicable). Choose between competitive per-kilometer rates or all-inclusive Goa trip packages tailored to your needs and duration."
    },
    {
        "WhyChooseheading": "Clean & Sanitized Vehicles with Top Safety Standards",
        "WhyChoosedescription": "Every Innova cab is thoroughly cleaned and sanitized before your trip. Our vehicles come equipped with seat belts for all passengers, a first aid kit, and regular vehicle health checks. Your safety and hygiene are our highest priority, especially for long-distance journeys like Pune to Goa."
    },
    {
        "WhyChooseheading": "24/7 Support & Easy Booking Process",
        "WhyChoosedescription": "Book your Pune to Goa Innova cab easily via WhatsApp, phone, or our online platform. Our customer support team is available 24/7 to assist with planning, route selection, stopovers, and last-minute schedule changes. We’re here to ensure your trip to Goa is smooth, on-time, and enjoyable."
    }
]



















    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Innova cab service from Pune to Goa?',
        answer: 'Yes, Prince Cabs provides reliable and comfortable Toyota Innova and Innova Crysta cab services for outstation travel from Pune to Goa—perfect for groups and families.',
    },
    {
        question: 'What is the fare for Pune to Goa Innova cab?',
        answer: 'The fare for a one-way trip from Pune to Goa in an Innova starts at ₹10,500. Rates vary depending on the route, type of Innova, and travel preferences.',
    },
    {
        question: 'How long is the drive from Pune to Goa by Innova cab?',
        answer: 'The journey takes approximately 9 to 11 hours, depending on the selected route and traffic conditions. Our Innova cabs ensure a smooth and comfortable ride.',
    },
    {
        question: 'Can I book an Innova Crysta for my Pune to Goa trip?',
        answer: 'Yes, you can opt for a premium Innova Crysta that offers captain seats, rear AC vents, extra legroom, and smooth suspension for a luxurious travel experience.',
    },
    {
        question: 'Are round trips available for Pune to Goa in Innova?',
        answer: 'Absolutely! We offer customizable round-trip packages from Pune to Goa with flexible return dates and multi-day tour options.',
    },
    {
        question: 'Are tolls, taxes, and driver allowance included in the fare?',
        answer: 'Tolls, border taxes, and driver allowance are usually charged separately from the base fare. We provide a complete cost breakdown at the time of booking.',
    },
    {
        question: 'How do I book an Innova cab from Pune to Goa with Prince Cabs?',
        answer: 'You can easily book through our website or call our customer support team. Share your travel dates and preferences, and we’ll arrange a clean, well-maintained Innova cab for you.',
    },
];

const testimonials = [
    {
        name: "Mr. Ajay Naik",
        position: "Leisure Traveler",
        text: "We booked an Innova Crysta from Pune to Goa for a family vacation. It was super comfortable and the driver was very polite and professional.",
        image: "/img/testimonial/testimonial-thumb-goa-1.png",
    },
    {
        name: "Ms. Richa Menon",
        position: "Corporate Executive",
        text: "Our Pune to Goa road trip was amazing thanks to Prince Cabs. The Innova was in top condition and the service was prompt. Highly recommended!",
        image: "/img/testimonial/testimonial-thumb-goa-2.png",
    },
];

























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Innova Cab",
  "image": "https://princecab.com/assets/images/pune-to-goa-innova-cab.jpg",
  "description": "Book Pune to Goa Innova cab with Prince Cabs for a comfortable, spacious, and reliable journey. Perfect for family trips and group travel with affordable and luxury options.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "9000"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7500",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-goa-innova-cab"
  }
};




    return (
        <div>
<Helmet>
  <title>Pune to Goa Innova Cab | Comfortable & Affordable | Prince Cabs</title>
  <meta
    name="description"
    content="Book Pune to Goa Innova cab with Prince Cabs for a comfortable, spacious, and reliable journey. Perfect for family trips and group travel with affordable and luxury options."
  />
  <meta
    name="keywords"
    content="Pune to Goa Taxi Fare, Pune to Goa Cab Booking, Pune to Goa Innova Cab Booking, Innova Taxi in Pune, 7 Seater Innova on Rent in Pune, Pune to Goa Innova Cab Package Service, Pune to Goa Innova Cab Online Booking, Pune to Goa Innova Cab Service, Pune to Goa Crysta Cab Fare, Pune to Goa Dzire vs Innova Taxi, Pune to Goa Family Innova, Pune to Goa Affordable Innova Cab, Luxury Innova Pune to Goa, Pune to Goa Innova Crysta Hire, Pune to Goa Innova Round Trip Booking"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/39.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetogoainnovacab ;